import Api from '@/api/index';

const Bank = {
  namespaced: true,
  state: { //dado read only, e qm pode alterar esses dados são as mutations! VARIAVEIS
    allBanks: null, //para o index, e vai tomar um push(newEmployee ao criar)
    errorMessage: null,
    errorActive: null,
  },
  mutations: {// altera os dados do state
    getBanks(state, banks){
      state.allBanks = banks.data;
      
    },

    setErrorMessage(state, {message, status}){
      state.errorMessage = message;
      state.errorActive = status;
    }
  },
  actions: { //chamar o método dentro dos componentes
    index(context){
      Api.Bank.index()
        .then(response => response.data)
        .then(banks => {
          context.commit('getBanks', banks);
          context.commit('setErrorMessage', {message: '', status: false})
        }).catch(function(error) {
          console.log('erro no models - Bank');
          console.log(error);
        });
    },
  }
};

export default Bank;